export default {
  data() {
    return {
      query: '',
    };
  },
  methods: {
    onSubmit() {
      const q = this.query.trim();
      if (!q) return;
      this.$router.push({ path: '/markets/search', query: { query: q } });
    },
  },
};
